export default "__VITE_ASSET__rx$aoSCx__"